import React from 'react';
import SVG from 'react-inlinesvg';

const Empty = (props) => {
  return (
    <div id="searchandfilter-filter-empty-wrapper" className="h-[94%]">
      <div
        id="searchandfilter-filter-empty-container"
        className="flex flex-col justify-center items-center h-full"
      >
        <div
          id="searchandfilter-filter-empty-sub-container"
          className="flex flex-col items-center min-width-[390px] min-height-[511px]"
        >
          <div
            id="searchandfilter-filter-empty-icon"
            className="flex flex-row justify-center gap-[16px]"
          >
            <SVG src={`SvgIcons/FilterPanel/SilverFilterLarge.svg`} />
          </div>
          <div
            id="searchandfilter-filter-empty-message"
            className="text-[#b4b4b4] font-normal text-base"
          >
            {"Please select 'ADD FILTER' to add filter parameters"}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Empty;
